/** Monotone display-tone calibration; source PNGs and every alpha byte remain untouched. */
export function validateColorGrade(grade) {
  if (!grade || !Array.isArray(grade.gain) || !Array.isArray(grade.gamma) ||
      grade.gain.length !== 3 || grade.gamma.length !== 3 ||
      grade.gain.some(v => !Number.isFinite(v) || v < .8 || v > 1.2) ||
      grade.gamma.some(v => !Number.isFinite(v) || v < .8 || v > 1.35)) {
    throw new Error('Invalid or excessive color grade');
  }
}

export function applyColorGrade(rgba, grade) {
  validateColorGrade(grade);
  if (!(rgba instanceof Uint8ClampedArray) || rgba.length % 4) throw new Error('Invalid RGBA buffer');
  const tables = grade.gain.map((gain, channel) => Uint8ClampedArray.from({length: 256}, (_, value) =>
    Math.round(255 * gain * (value / 255) ** grade.gamma[channel])));
  const result = rgba.slice();
  for (let i = 0; i < result.length; i += 4) {
    if (rgba[i + 3] === 0) continue;
    for (let channel = 0; channel < 3; channel++) result[i + channel] = tables[channel][rgba[i + channel]];
  }
  return result;
}

export function prepareColorTexture(doc, image, grade) {
  if (grade === undefined) return image;
  validateColorGrade(grade);
  const canvas = doc.createElement('canvas');
  canvas.width = image.naturalWidth;
  canvas.height = image.naturalHeight;
  const context = canvas.getContext('2d', {willReadFrequently: true});
  if (!context) throw new Error('Color calibration canvas unavailable');
  context.drawImage(image, 0, 0);
  const pixels = context.getImageData(0, 0, canvas.width, canvas.height);
  pixels.data.set(applyColorGrade(pixels.data, grade));
  context.putImageData(pixels, 0, 0);
  return canvas;
}
